<template>
  <div>
    <br/>
    <h5 class="pageTitle">Boutique</h5>
    <div class="productsContainer">
      <product
          v-for="product in products"
          :product="product"
          :key="product.id"
      />
    </div>
    <br/>
  </div>
</template>

<script>
  import { mapState, mapActions } from 'vuex';
  import config from '../../config';
  import Product from '../../components/Produits/Produit_Panier_Index';
  import _ from 'lodash';

  export default {
    name: 'boutique',
    components: { Product },
    data() {
      return {
        config
      };
    },
    created() {
      this.getAllProducts();
    },
    computed: {
      ...mapState({
        products: state => state.products.all,
        connected: state => state.account.status.loggedIn
      })
    },
    methods: {
      ...mapActions('products', {
        getAllProducts: 'getAll'
      }),
      addToCart(id) {
        const self = this;
        const product = _.find(this.products, function(product) {
          return product.id === id;
        });

        const showError = function(error) {
          self.$swal({
            type: 'error',
            title: 'Impossible d\'ajouter au panier',
            text: error
          });
        };

        if (_.isUndefined(product)) {
          showError('Produit introuvable');
        }
        else {
          this.addProductToCart({
            type: 'entry',
            quantity: 1,
            product,
            amount:
              this.connected === true ? product.priceMember : product.priceGeneral
          }).then(
            function(success) {
              self.$swal({
                toast: true,
                position: 'bottom-end',
                showConfirmButton: false,
                timer: 3000,
                type: 'success',
                title: 'Item ajouté au panier'
              });
            },
            function(error) {
              showError(error);
            }
          );
        }
      }
    }
  };
</script>

<style lang="scss" scoped>
.productsContainer {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  align-items: center;
}
</style>
